// src/pages/ECommercePage.jsx
import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";

const MatrixEcommerceBackground = () => {
  useEffect(() => {
    const canvas = document.getElementById("matrix-ecommerce-bg");
    const context = canvas.getContext("2d");

    let width = window.innerWidth,
        height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    const katakana = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン";
    const latin = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const nums = "0123456789";
    const alphabet = katakana + latin + nums;
    const fontSize = 16;
    const columns = width / fontSize;
    const rainDrops = new Array(Math.floor(columns)).fill(1);

    const draw = () => {
      context.fillStyle = "rgba(0,0,0,0.05)";
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#0F0";
      context.font = fontSize + "px monospace";
      for (let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        context.fillText(text, i * fontSize, rainDrops[i] * fontSize);
        if (rainDrops[i] * fontSize > height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        }
        rainDrops[i]++;
      }
    };

    const interval = setInterval(draw, 30);
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <canvas
      id="matrix-ecommerce-bg"
      className="fixed top-0 left-0 w-full h-full opacity-20 pointer-events-none"
    />
  );
};

const ECommercePage = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);
  return (
    <section className="relative min-h-screen bg-gray-900 text-white overflow-hidden">
      <NavBar />
      <MatrixEcommerceBackground />
      <div className="relative z-10 container mx-auto px-4 py-16">
        {/* Header */}
        <header
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h1 className="text-5xl font-bold font-mono text-green-500 mb-4">
            E-Commerce Solutions
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            AIOrbis powers next‑generation e‑commerce platforms that blend innovative design with robust performance. Our solutions drive conversion and scale seamlessly as your business grows.
          </p>
        </header>

        {/* Overview Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4 text-center">
            Overview
          </h2>
          <p className="text-gray-300">
            Our e‑commerce systems are designed to create immersive online shopping experiences. Leveraging data‑driven insights and advanced technologies, we develop solutions that are secure, scalable, and tailored to meet the dynamic demands of modern retail.
          </p>
        </section>

        {/* Features Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4 text-center">
            Key Features
          </h2>
          <ul className="list-disc ml-8 text-gray-300 space-y-2">
            <li>Responsive & User‑Friendly Interface</li>
            <li>Secure Payment Gateways & Data Encryption</li>
            <li>Real‑Time Inventory Management</li>
            <li>Seamless Integration with Third‑Party APIs</li>
            <li>Advanced Analytics & Conversion Tracking</li>
          </ul>
        </section>

        {/* Call-to-Action */}
        <section className="text-center">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4">
            Ready to Transform Your Retail Experience?
          </h2>
          <p className="text-gray-300 mb-8">
            Partner with AIOrbis for a cutting‑edge e‑commerce solution that drives growth and innovation.
          </p>
          <a
            href="/contact"
            className="px-8 py-3 bg-green-600 hover:bg-green-500 text-white font-mono rounded-lg transition-colors duration-300"
          >
            Contact Us
          </a>
        </section>
      </div>
    </section>
  );
};

export default ECommercePage;
